module.exports = __webpack_public_path__ + "img/head.22bc3e8d.webp";